import React from 'react'
import './SwipeButtons.css'
import ReplayIcon from '@material-ui/icons/Replay'
import CloneIcon from '@material-ui/icons/Close'
import StarRateIcon from '@material-ui/icons/StarRate'
import FavoriteIcon from '@material-ui/icons/Favorite'
import FlashOnIcon from '@material-ui/icons/FlashOn'
import IconButton from '@material-ui/core/IconButton'

const SwipeButtons = () => {
  return (
    <div className='swipeButtons'>
      <IconButton>
        <ReplayIcon fontSize='large' color="primary" />
      </IconButton>
      <IconButton>
        <CloneIcon fontSize='large' />
      </IconButton>
      <IconButton>
        <StarRateIcon fontSize='large' />
      </IconButton>
      <IconButton>
        <FavoriteIcon fontSize='large' color="secondary" />
      </IconButton>
      <IconButton>
        <FlashOnIcon fontSize='large' />
      </IconButton>
    </div>
  )
}

export default SwipeButtons